
import {
  getBlockAbove,
  getPlugin,
  insertNodes,
  insertText,
  isEndPoint,
  moveSelection,
  focusEditor,
} from '@udecode/plate-common';

import { ELEMENT_MERGE_FIELD } from './createMergeFieldsPlugin';

export const getMergeFieldOnSelectItem = ({
    key = ELEMENT_MERGE_FIELD,
  } = {}) =>
  (editor, value, search = '') => {
    const {
      options: { createMergeFieldNode, insertSpaceAfterMergeField },
      type,
    } = getPlugin(editor, key);

    const props = createMergeFieldNode(value, search);

    insertNodes(editor, {
      children: [{ text: '' }],
      type,
      ...props,
    });

    // move the selection after the element
    moveSelection(editor, { unit: 'offset' });

    const pathAbove = getBlockAbove(editor)?.[1];

    const isBlockEnd =
      editor.selection &&
      pathAbove &&
      isEndPoint(editor, editor.selection.anchor, pathAbove);

    if (isBlockEnd && insertSpaceAfterMergeField) {
      insertText(editor, ' ');
    }

    focusEditor(editor);
  };
